import React from "react";

const Footer = () => {
  return (
    <footer className="bg-white shadow-inner text-center py-3 text-sm text-gray-600 mt-8">
      © {new Date().getFullYear()} NCCF | All rights reserved.
    </footer>
  );
};

export default Footer;
